import { useRef } from 'react'
import { useI18n } from '../i18n.jsx'
import useFloatingArtwork from './useFloatingArtwork.js'
import useHeroViewport from './useHeroViewport.js'

const drawings = [
  { name: 'TRV801', className: 'line-trv801', width: 533, height: 980 },
  { name: 'T9', className: 'line-t9', width: 1216, height: 870 },
  { name: 'TRV706', className: 'line-trv706', width: 608, height: 960 },
  { name: 'V4', className: 'line-v4', width: 801, height: 800 },
  { name: 'TRV601', className: 'line-trv601', width: 595, height: 963 },
  { name: 'RC5P', className: 'line-rc5p', width: 860, height: 860 },
  { name: 'T5', className: 'line-t5', width: 765, height: 800 },
]

export default function Hero() {
  const { t } = useI18n()
  const artworkRef = useRef(null)
  useHeroViewport(artworkRef)
  useFloatingArtwork(artworkRef)
  return <section id="top" className="hero blueprint-hero hero--a" data-composition="a">
    <div className="hero-inner">
      <div className="hero-main">
        <div className="hero-copy">
          <h1 className="hero-wordmark"><span className="hero-text-line">Rti-Tek</span></h1>
          <h2 className="hero-positioning"><span className="hero-text-line">{t('site.hero_title')}</span></h2>
        </div>
        <div className="hero-drawings" ref={artworkRef} aria-hidden="true">
          <div className="drawing-fills">
            {drawings.map((drawing) => <img className={`drawing-fill ${drawing.className}`} data-model={drawing.name} key={drawing.name} src={`/assets/product-fills/${drawing.name}.svg?v=line-icons-20261016`} alt="" width={drawing.width} height={drawing.height} style={{ '--source-width': `${drawing.width}px` }} />)}
          </div>
          {drawings.map((drawing, index) => <figure className={`line-drawing ${drawing.className}`} data-model={drawing.name} key={drawing.name} style={{ '--source-width': `${drawing.width}px`, '--caption-delay': `${-index * 2.7}s` }}>
            <img src={`/assets/product-lines/${drawing.name}.svg?v=line-icons-20261016`} alt="" width={drawing.width} height={drawing.height} fetchPriority={drawing.name === 'T9' ? 'high' : 'auto'} />
            <figcaption className="drawing-caption hero-drawing-caption">
              <span className="drawing-model">{drawing.name}</span>
              <span className="drawing-description">
                <span>{drawing.name.startsWith('TRV') ? t('site.application_radiator') : 'HVAC'}</span>
                <span>OEM / ODM</span>
              </span>
            </figcaption>
          </figure>)}
        </div>
      </div>
    </div>
  </section>
}
